import React from 'react'
import "./ProjectCard.css"
import { FaGithub } from 'react-icons/fa'
export default function ProjectCard({name,description,imgurl,prolink,webimg,gitrepo}) {
   
    function getGit(){
      window.location.href=gitrepo
      }
      function getPro(){
        window.location.href=prolink
      }
  return (
    <>
        <div className='container'>
            <div id='left'>
                <img id='img' src={imgurl} alt="" />
            </div>
            <div id='right'>
                    <h2>{name}</h2>
                    <br />
                    <h4>{description}</h4>
                    <br />
                    <div id='icon'>
                            <FaGithub onClick={()=>{getGit()}} size={45}/>
                            <img onClick={()=>{getPro()}} id='webimg' src={webimg} alt=""/>
                    </div>
                   
            </div>

        </div>
    </>
  )
}
